var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @desc chart title
 */
import { Group } from '../../element';
import { createRichText } from '../../rich';
import ComponentModel from '../../model/componentModel';
import { registerComponent } from '../index';
/**
 * title class
 */
var TitleModel = /** @class */ (function (_super) {
    __extends(TitleModel, _super);
    function TitleModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'title';
        _this.zindex = 100;
        return _this;
    }
    TitleModel.prototype.getDefaultOption = function () {
        return {
            show: true,
            floating: false,
            text: '',
            subtext: '',
            align: 'left',
            verticalAlign: 'top',
            margin: 24,
            itemGap: 8,
            offsetX: 0,
            offsetY: 0,
            textStyle: {
                color: '#303443',
                fontSize: 14,
                fontWeight: 'bold',
            },
            subtextStyle: {
                color: '#878EA8',
                fontSize: 12,
            },
        };
    };
    TitleModel.prototype.getInitialState = function () {
        return {
            x: 0,
            y: 0,
            textAlign: 'left',
            textBaseline: 'bottom',
        };
    };
    TitleModel.prototype.beforeRender = function () {
        var _a = this.chart.getPaddingBox(), top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
        var _b = this.option, show = _b.show, floating = _b.floating, align = _b.align, verticalAlign = _b.verticalAlign, offsetX = _b.offsetX, offsetY = _b.offsetY;
        if (!show) {
            return;
        }
        var sideValue;
        var x = 0;
        var y = 0;
        var textBaseline;
        var textAlign;
        if (floating) {
            if (verticalAlign === 'top') {
                sideValue = top;
            }
            else if (verticalAlign === 'bottom') {
                sideValue = bottom;
            }
        }
        else {
            sideValue = this.chart.getSidePosition(this.id);
        }
        if (align === 'left') {
            x = left;
            textAlign = 'left';
        }
        else if (align === 'right') {
            x = right;
            textAlign = 'right';
        }
        else if (align === 'center') {
            textAlign = 'center';
            x = (left + right) / 2;
        }
        if (verticalAlign === 'top') {
            textBaseline = 'top';
            y = sideValue;
        }
        else if (verticalAlign === 'middle') {
            textBaseline = 'middle';
            y = (top + bottom) / 2;
        }
        else if (verticalAlign === 'bottom') {
            textBaseline = 'bottom';
            y = sideValue;
        }
        x += offsetX;
        y += offsetY;
        this.setState({
            x: x,
            y: y,
            textAlign: textAlign,
            textBaseline: textBaseline,
        });
    };
    TitleModel.prototype.getSideAreaSize = function () {
        var _a = this.option, show = _a.show, text = _a.text, subtext = _a.subtext, floating = _a.floating, textStyle = _a.textStyle, subtextStyle = _a.subtextStyle, itemGap = _a.itemGap, verticalAlign = _a.verticalAlign, margin = _a.margin;
        if (verticalAlign === 'middle' || !show || floating || !text) {
            return {
                side: 'right',
                size: 0,
            };
        }
        return {
            side: verticalAlign,
            size: textStyle.fontSize + margin + (subtext ? subtextStyle.fontSize + itemGap : 0),
        };
    };
    TitleModel.prototype.render = function () {
        var _a = this.option, show = _a.show, text = _a.text, subtext = _a.subtext, textStyle = _a.textStyle, subtextStyle = _a.subtextStyle, itemGap = _a.itemGap;
        var _b = this.state, x = _b.x, y = _b.y, textAlign = _b.textAlign, textBaseline = _b.textBaseline;
        var group = new Group({
            key: this.getKey('title'),
        });
        if (show) {
            group.add(createRichText(__assign(__assign({ text: text,
                x: x,
                y: y }, this.getTextStyle(this.option.textStyle)), { textAlign: textAlign,
                textBaseline: textBaseline })));
            if (subtext) {
                group.add(createRichText(__assign(__assign({ text: subtext, x: x, y: y + itemGap + textStyle.fontSize }, this.getTextStyle(subtextStyle)), { textAlign: textAlign,
                    textBaseline: textBaseline })));
            }
        }
        return group;
    };
    return TitleModel;
}(ComponentModel));
export default TitleModel;
registerComponent('title', TitleModel);
